<template>
  <card>
    <div v-if="$store.state.navs[$options.name]">
      <div v-for="f in staticFilter" :key="f.key">
        <label>{{ f.title }}</label>
        <radio-list
          :name="`${f.key}-filter`"
          v-model="params[f.key]"
          :items="f.items"
        />
      </div>
      <hr />
      <h5>Фильтры</h5>
      <div class="row">
        <div v-for="filter in filters" :key="filter.key" class="col-6 col-md-4">
          <filter-item
            :modal="filter.key"
            :title="filter.title"
            v-model="params[`${filter.key}_id`]"
          />
        </div>
      </div>
      <list
        :columns="columns"
        :modalCreate="modalCreate"
        :removeLink="removeLink"
        :cardLink="cardLink"
        :isUpdate="true"
        :isAdd="true"
        :itemLink="itemLink"
        :params="params"
        :fields="fields"
        @change="change"
        :setLink="setLink"
        v-model="val"
        :orderBy="`created_at`"
      />
    </div>
  </card>
</template>

<script>
import List from "../components/List";
/**Меняю добавление модалку */

import { mapState } from "vuex";
export default {
  name: "Orders",
  components: {
    List,
    FilterItem: () => import("../components/Filter"),
    RadioList: () => import("../components/Filters/RadioList"),
  },
  data() {
    return {
      filters: [
        {
          key: "status",
          title: "Статусы заказов",
        },
        {
          key: "client",
          title: "Клиенты",
        },
        {
          key: "shop",
          title: "Магазины",
        },
        // {
        //   key: "type",
        //   title: "Вид покупки",
        // },
      ],
      staticFilter: [
        {
          title: "Статус оплаты",
          key: "paid",
          default: "0",
          items: [
            {
              id: 0,
              title: "Все",
            },
            {
              id: 1,
              title: "Оплачен",
            },
            {
              id: 2,
              title: "Не оплачен",
            },
          ],
        },
        {
          title: "Формировал заказ",
          key: "moderator",
          default: "0",
          items: [
            {
              id: 0,
              title: "Любой",
            },
            {
              id: 1,
              title: "Клиент",
            },
            {
              id: 2,
              title: "Модератор",
            },
          ],
        },
      ],
      restart: false,
      params: {
        paid: 0,
      },
      fields: [
        {
          key: "name",
          label: "Имя заказчкиа",
          type: "field",
          textType: "text",
        },
        {
          key: "phone",
          label: "Контактный номер заказчика",
          type: "mask",
          mask: "+998 ## ### ## ##",
        },
      ],
      /**Меняю ссылки на модель */
      modalCreate: "order",
      removeLink: "group/remove",
      cardLink: "order",
      itemLink: "orders/list",
      setLink: "orders/add",
      /**Табличные филды */
      columns: [
        {
          key: "id",
          title: "ID заказа",
          checkbox: false,
          control: false,
          full: true,
          align: "left",
        },
        {
          key: "created_at",
          full: true,
          title: "Дата и время",
          checkbox: false,
          control: false,
          dateTimeFormat: true,
          sortBy: "created_at",
        },
        {
          key: "status",
          title: "Статус",
          full: true,
          object: "title",
          align: "left",
        },
        {
          key: "payment",
          title: "Метод оплаты",
          checkbox: false,
          control: "info",
          object: "title",
          align: "left",
        },
        {
          key: "price",
          title: "Сумма на оплату",
          checkbox: false,
          control: "info",
          align: "left",
          sortBy: "price",
          filter: "spaceBetweenNumber",
        },
        {
          key: "is_paid",
          title: "Оплачено",
          checkbox: false,

          align: "left",
        },
        {
          key: "customer",
          title: "Клиент",
          object: "name",
          checkbox: false,
          control: false,
          align: "left",
        },
        {
          key: "customer",
          title: "Контактный номер",
          checkbox: false,
          object: "phone",
          control: false,
        },
        // {
        //   key: "promocode",
        //   title: "Промокод",
        //   object: "name",
        //   checkbox: false,
        //   control: "info",
        //   align: "left",
        // },
        // {
        //   key: "bonus",
        //   title: "Применил бонусы",
        //   object: "value",
        //   checkbox: false,
        //   control: "info",
        //   align: "left",
        // },

        {
          key: "",
          full: true,
          title: "",
          checkbox: false,
          detail: true,
          align: "right",
        },
      ],
      value: null,
      val: [],
    };
  },
  methods: {
    changeFunction(val) {},
    change(val) {
      this.value = Array.isArray(val) ? val : [val];
    },
  },
  computed: {
    ...mapState(["listState"]),
  },
};
</script>
<style>
</style>
